import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
// Object-Path
import * as objectPath from "object-path";
// Layout
import { LayoutConfigModel } from "../../../../interfaces/home/layout-config";
import { SplashScreenService } from "../../../../services/home/splash-screen.service";

@Component({
  selector: "splash-screen",
  templateUrl: "./splash-screen.component.html",
  styleUrls: ["./splash-screen.component.css"]
})
export class SplashScreenComponent implements OnInit {
  // Public proprties
  config: LayoutConfigModel;
  loaderLogo: string;
  loaderType: string;
  loaderMessage: string;

  @ViewChild("splashScreen", { static: true }) splashScreen: ElementRef;

  /**
   * Component constructor
   *
   * @param el: ElementRef
   * @param layoutConfigService: LayoutConfigService
   * @param splashScreenService: SplachScreenService
   */
  constructor(
    private el: ElementRef,
    private splashScreenService: SplashScreenService
  ) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit() {
    // init splash screen, see loader option in layout.config.ts
    this.config = JSON.parse(localStorage.getItem("layoutConfig"));
    //const loaderConfig = this.layoutConfigService.getConfig("loader");
    const loaderConfig = objectPath.get(this.config, "loader");
    this.loaderLogo = objectPath.get(loaderConfig, "logo");
    
    this.loaderType = objectPath.get(loaderConfig, "type");
    this.loaderMessage = objectPath.get(loaderConfig, "message");

    this.splashScreenService.init(this.splashScreen);
  }
}
